import PropTypes from 'prop-types';
// @mui
import { Grid } from '@mui/material';
import EventCard from './EventCard';

// ----------------------------------------------------------------------

EventList.propTypes = {
  events: PropTypes.array.isRequired,
  bookedIds: PropTypes.array,
};

export default function EventList({ events, bookedIds = [], ...other }) {
  return (
    <Grid container spacing={3} {...other}>
      {events.map((event) => (
        <Grid key={event.id} item xs={12} sm={6} md={3}>
          <EventCard event={event} booked={bookedIds.includes(event.id)} />
        </Grid>
      ))}
    </Grid>
  );
}
